import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoaderModule } from '@app/core/components/loader/loader.module';
import { RcDialogWrapperComponent } from './rc-dialog-wrapper.component';

@NgModule({
  imports: [CommonModule, LoaderModule],
  declarations: [RcDialogWrapperComponent],
  exports: [RcDialogWrapperComponent],
})
export class RCDialogWrapperModule {}
